import { type BaseApiContract } from "shared/api/BaseApiContract";
import { HttpMethod } from "shared/api/http";
import { type SocietyProfileParamsInput } from "shared/api/types/society/[societyId]/profiles/[profileId]/index";
import { type UnreadNotificationCountResponse } from "shared/api/types/society/[societyId]/profiles/[profileId]/notifications";
export const getSocietyProfileNotificationsUnreadCountContract: BaseApiContract<
  SocietyProfileParamsInput,
  undefined,
  UnreadNotificationCountResponse
> = {
  method: HttpMethod.GET,
  apiRoute:
    "/api/v1/society/[societyId]/profiles/[profileId]/notifications/unread-count",
  paramsType: {} as SocietyProfileParamsInput,
  responseType: {} as UnreadNotificationCountResponse,
};
